function createRequestTypes(type) {
  let data = {};
  let typesOfCalls = ['REQUEST', 'SUCCESS', 'FAILURE'];
  typesOfCalls.map(item => {
    const key = type + '_' + item;
    Object.assign(data, {
      [key]: key,
    });
  });
  return data;
}

export const CMS_DETAILS = createRequestTypes('CMS_DETAILS');
